export enum ProductionFournitureClient {
    CCS = 'ccs',
    CCMP = 'ccmp',
}

export enum ProductionFournitureMode {
    FOURNITURES = 'fournitures',
    CENTRES = 'centres'
}

export enum ExportPostscriptEnabled {
    NO,
    YES
}
